import React from 'react';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
  bold: {
    fontWeight: 'bold',
    color: '#4D4D4D'
  },
  padding20: {
    paddingLeft: 20
  },
  name: {
    fontWeight: 'bold',
    color: '#4D4D4D',
    fontSize: '0.9em',
  },
  value: {
    color: '#4D4D4D',
    fontSize: '0.9em'
  },
  header: {
    backgroundColor: '#0072BC',
    paddingTop: 6,
    paddingBottom: 6,
    color: '#ffffff'
  },
  headerSuccess: {
    backgroundColor: '#28a745',
    paddingTop: 6,
    paddingBottom: 6,
    color: '#ffffff'
  },
  headerWarning: {
    backgroundColor: '#ffc107',
    paddingTop: 6,
    paddingBottom: 6,
    color: '#ffffff'
  },
  headerError: {
    backgroundColor: '#dc3545',
    paddingTop: 6,
    paddingBottom: 6,
    color: '#ffffff'
  },
  table: {
  },
  even: {
    fontSize: '0.8em',
    backgroundColor: '#F2F2F2',
    border: 'none'
  },
  odd: {
    fontSize: '0.8em',
    border: 'none'
  },
  tableheader: {
    backgroundColor: '#B6D0FB',
    color: '#4D4D4D',
    border: '1px solid #B6D0FB'
  },
  tableheader_cell: {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 10,
    paddingRight: 10

  },
  table_cell: {
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 10,
    paddingRight: 10
  },
  maingrid: {
    marginTop: 20,
    marginBottom: 20
  }
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: '#ffffff'
  },
});

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, variant= "h6", typographyProps = {}, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant={variant} {...typographyProps}>{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} size="small" onClick={onClose}>
            <CloseIcon color="inherit" />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

const CustomDialog = ({open,onClose,maxWidth='md',title = '',propsTitle={}, children, msgType,propsDialog={}, PaperProps={}, ...props})=>{

    const classess = useStyles();
    const handleClose = () => {
        if(onClose)
        {
            onClose();
        }
    };
    
    let titleclass = classess.header
    switch(msgType){
      case "error" :
        titleclass = classess.headerError
        break
      case "warning" :
        titleclass = classess.headerWarning
         break
      case "success" :
        titleclass = classess.headerSuccess
          break
    }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-history-dialog-title"
        aria-describedby="dialog-history-dialog-description"
        fullWidth 
        maxWidth={maxWidth}
        PaperProps={PaperProps}
        {...propsDialog}
      >
        <DialogTitle onClose={handleClose} className={titleclass}  id="dialog-history-dialog-title" {...propsTitle}>{title}</DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CustomDialog;